import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ButtonWrapper = styled(Stack)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  > * {
    flex: 1;
  }
`;
